import axios from 'axios'

export function resetStory() {
  return {
    type: 'STORY_RESET',
  }
}

export function fetchStory(id) {
  return (dispatch) =>
    dispatch({
      type: 'STORY_FETCH',
      payload: axios(`/stories/${id}`),
    })
}

export default fetchStory
